@if (user$ | async; as user) {
  <ui-user-data
    (submitResult)="onUserDataSubmit($event)"
    [user]="user"
  ></ui-user-data>
}

@if (changePasswordUrl$ | async; as changePasswordUrl) {
  <ui-user-password
    [passwordUrl]="changePasswordUrl"
    (linkClicked)="onUserPasswordChangeClicked()"
  ></ui-user-password>
}
